import PAGES from '../app/data/PagesConstants';
import UI_ACTIONS from '../app/data/UiActionConstants';
import DashboardPage from '../app/pages/DashboardPage';
import CirclesListingPage from '../app/pages/circles/Index';
import NewCirclePage from '../app/pages/circles/New';
import ShowCirclePage from '../app/pages/circles/Show';
import EditCirclePage from '../app/pages/circles/Edit';
import ClustersListingPage from '../app/pages/clusters/Index';
import NewClusterPage from '../app/pages/clusters/New';
import ShowClusterPage from '../app/pages/clusters/Show';
import EditClusterPage from '../app/pages/clusters/Edit';
import StatesListingPage from '../app/pages/states/Index';
import ChargingStationDiagnosticsPage from '../app/pages/charging_station_diagnostics/IndexForm';
import ChargingStationVersionUpdatePage from '../app/pages/cs_version_update/Main';
import CustomersListingPage from "../app/pages/customers/Index";
import ShowCustomerPage from "../app/pages/customers/Show";
import DistributorsListingPage from "../app/pages/distributor/Index";
import DistributorDetailsPage from "../app/pages/distributor/Show";
import FleetOwnersListingPage from '../app/pages/fleet_owners/Index';
import ShowFleetOwnerPage from "../app/pages/fleet_owners/Show";
import BatteriesListingPage from "../app/pages/batteries/Index";
import VehiclesListingPage from "../app/pages/vehicle/Index";
import VehicleTypesListingPage from "../app/pages/vehicle_types/Index";
import InspectionsItemsPage from "../app/pages/inspection_items/Index";
import WarehousesListingPage from "../app/pages/warehouses/Index"
import BatteryModelsListingPage from "../app/pages/battery_models/Index";
import NewBatteryModelPage from "../app/pages/battery_models/New";
import EditBatteryModelPage from "../app/pages/battery_models/Edit"
import ChargingStationsListingPage from "../app/pages/charging_stations/Index";
import EarningsListingPage from '../app/pages/earnings/Index';
import PartnerBillingsListingPage from '../app/pages/partner_billings/Index';
import PartnerBillingsShowPage from '../app/pages/partner_billings/Show';
import PerDayEarningShowPage from '../app/pages/earnings/PerSwapIndex';
import ElectricityBillingsListingPage from '../app/pages/partner_billings/Index';
import ElectricityClaimsListingPage from '../app/pages/electricity/claims/Index'
import ElectricityConfigsListingPage from '../app/pages/electricity/config/Index';
import ElectricityServiceProvidersListingPage from '../app/pages/electricity/providers/Index';
import OffersListingPage from '../app/pages/offers/Index';
import NewOfferPage from '../app/pages/offers/New';
import EditOfferPage from '../app/pages/offers/Edit';
import LeaseOfferListingTab from '../app/pages/lease_offers/Listing';
import NewLeaseOfferPage from '../app/pages/lease_offers/New';
import EditLeaseOfferPage from '../app/pages/lease_offers/Edit';
import RolloverConfigsPage from '../app/pages/lease_offers/roll_over_configs/Index';
import NewRollOverConfigPage from '../app/pages/lease_offers/roll_over_configs/New';
import EditRollOverConfigPage from '../app/pages/lease_offers/roll_over_configs/Edit';
import PermissionsConfigPage from '../app/pages/PermissionsConfigPage';
import CrmUsersListingPage from '../app/pages/crm_users/Index';
import NewCrmUserPage from '../app/pages/crm_users/New';
import EditCrmUserPage from '../app/pages/crm_users/Edit';
import WorkOrdersListingPage from '../app/pages/work_orders/Index';
import ShowWorkOrdersPage from '../app/pages/work_orders/Show';
import SchemesListingPage from '../app/pages/schemes/Index';
import NewSchemePage from '../app/pages/schemes/New';
import EditSchemePage from '../app/pages/schemes/Edit';
import SecurityAmountsListingPage from '../app/pages/security_amounts/Index';
import NewSecurityAmountPage from '../app/pages/security_amounts/New';
import EditSecurityAmountPage from '../app/pages/security_amounts/Edit';
import AddonsListingPage from '../app/pages/addons/Index';
import NewAddonPage from '../app/pages/addons/New';
import EditAddonPage from '../app/pages/addons/Edit';
import OfferAddonsListingPage from '../app/pages/offer_addons/Index';
import NewOfferAddonPage from '../app/pages/offer_addons/New';
import EditOfferAddonPage from '../app/pages/offer_addons/Edit';
import WalletCashbacksListingPage from '../app/pages/wallet_cashback/Index';
import BatteryTransactionsListingPage from '../app/pages/battery_transactions/Index';
import ServiceCentersListingPage from '../app/pages/service_center/Index'
import NewServiceCenterPage from '../app/pages/service_center/New'
import EditServiceCenterPage from '../app/pages/service_center/Edit'
import ShowServiceCenterPage from '../app/pages/service_center/Show'
import UploaderHistoryListingPage from '../app/pages/uploader_history/Index'
import ComplaintCategoriesListingPage from '../app/pages/complaint_categories/Index'
import NewComplaintCategoryPage from '../app/pages/complaint_categories/New'
import EditComplaintCategoryPage from '../app/pages/complaint_categories/Edit'
import GeneralReportsListingPage from '../app/pages/reports/general_reports';
import WalletTransactionsListingPage from '../app/pages/wallet_transactions/Index'
import TallyTransactionsListingPage from '../app/pages/tally_transaction/Index';
import RfidCardsListingPage from '../app/pages/rfids/Index';
import ChallansListingPage from '../app/pages/challans/Index';
import UploadFilesPage from '../app/pages/upload_files/UploadFilesPage';
import RentalBookingsPage from '../app/pages/rental_bookings/Index';
import RentalCustomersPage from '../app/pages/rental_customers/Index';
import ShowRentalCustomerPage from '../app/pages/rental_customers/Show';
import AssetEarningsConfigPage from '../app/pages/asset_earnings_config/Index';
import BikesListingPage from '../app/pages/bikes/Index';
import LeadsListingPage from '../app/pages/leads/Index';
import LeadsEarningConfigsPage from '../app/pages/leads_earning_config/Index';
import NewLeadsEarningConfigsPage from '../app/pages/leads_earning_config/New';
import EditLeadsEarningConfigsPage from '../app/pages/leads_earning_config/Edit';
import HeadUsersListingPage from "../app/pages/manage_users/Index";
import NewHeadUserPage from '../app/pages/manage_users/New';
import EditHeadUserPage from '../app/pages/manage_users/Edit';
import MapHeadUserPage from '../app/pages/manage_users/MapHeadUser';
import VoltUpAllocationKitListingPage from '../app/pages/voltup_allocation_kit/Index';
import NewVoltUpAllocationKitPage from '../app/pages/voltup_allocation_kit/New';
import EditVoltUpAllocationKitPage from '../app/pages/voltup_allocation_kit/Edit';
import PincodesListingPage from '../app/pages/pincodes/Index';
import NewPinCodePage from '../app/pages/pincodes/New';
import EditPinCodePage from '../app/pages/pincodes/Edit';
import VoltUpAllocationKitReportsListingPage from '../app/pages/vak_reports/Index';
import VoltUpAllocationKitTransactionsListingPage from '../app/pages/vak_transactions/Index';
import ChargingZonesMapPage from '../app/pages/charging_zones/Map'
import SearchUserPage from '../app/pages/search_user/SearchUser';
import ServiceTypeMappingPage from '../app/pages/service_type_mapping/Index';
import NewServiceTypeMappingPage from '../app/pages/service_type_mapping/New';
import SupportPage from '../app/pages/support/SupportPage';
import NewTechnicianPage from '../app/pages/technicians/New';
import EditTechnicianPage from '../app/pages/technicians/Edit';
import NewCoordinatorPage from '../app/pages/dsc_coordinator/New';
import EditCoordinatorPage from '../app/pages/dsc_coordinator/Edit';
import TransactionOrderListingPage from '../app/pages/transaction_orders/Index';
// import OperationsPage from '../app/pages/operations/OperationsPage';


const setupPages = (uiManager) => {
  uiManager.addUiPage(<DashboardPage />, PAGES.DashboardPage.name)

  uiManager.addUiPage(<CirclesListingPage />, PAGES.CirclesListingPage.name).addPageUiActions(
    uiManager,
    UI_ACTIONS.create_circle.name,
    UI_ACTIONS.view_circle.name,
    UI_ACTIONS.update_circle.name,
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.create_circle.name,
    uiManager.addUiPage(<NewCirclePage />, PAGES.NewCirclePage.name)
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.view_circle.name,
    uiManager.addUiPage(<ShowCirclePage />, PAGES.ShowCirclePage.name)
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.update_circle.name,
    uiManager.addUiPage(<EditCirclePage />, PAGES.EditCirclePage.name)
  )

  uiManager.addUiPage(<ClustersListingPage />, PAGES.ClustersListingPage.name).addPageUiActions(
    uiManager,
    UI_ACTIONS.create_cluster.name,
    UI_ACTIONS.view_cluster.name,
    UI_ACTIONS.update_cluster.name,

  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.create_cluster.name,
    uiManager.addUiPage(<NewClusterPage />, PAGES.NewClusterPage.name)
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.view_cluster.name,
    uiManager.addUiPage(<ShowClusterPage />, PAGES.ShowClusterPage.name)
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.update_cluster.name,
    uiManager.addUiPage(<EditClusterPage />, PAGES.EditClusterPage.name)
  )

  uiManager.addUiPage(<StatesListingPage />, PAGES.StatesListingPage.name)
  uiManager.addUiPage(<PincodesListingPage />, PAGES.PincodesListingPage.name).addPageUiActions(
    uiManager,
    UI_ACTIONS.create_pin_code.name,
    UI_ACTIONS.delete_pin_code.name,
    UI_ACTIONS.edit_pin_code.name,
    UI_ACTIONS.dissociate_pin_code.name,
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.create_pin_code.name,
    uiManager.addUiPage(<NewPinCodePage />, PAGES.NewPinCodePage.name)
  )

  uiManager.linkUiActionToPage(
    UI_ACTIONS.edit_pin_code.name,
    uiManager.addUiPage(<EditPinCodePage />, PAGES.EditPinCodePage.name)
  )

  uiManager.addUiPage(<ChargingStationDiagnosticsPage />, PAGES.ChargingStationDiagnosticsPage.name)

  uiManager.addUiPage(<ChargingStationVersionUpdatePage />, PAGES.ChargingStationVersionUpdatePage.name)

  uiManager.addUiPage(<CustomersListingPage />, PAGES.CustomersListingPage.name).addPageUiActions(
    uiManager,
    UI_ACTIONS.view_customer.name,
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.view_customer.name,
    uiManager.addUiPage(<ShowCustomerPage />, PAGES.ShowCustomerPage.name).addPageUiActions(
      uiManager,
      UI_ACTIONS.view_customer_transactions.name,
      UI_ACTIONS.view_customer_challans.name,
      UI_ACTIONS.view_customer_battery_swaps.name,
      UI_ACTIONS.view_user_documents.name
    )
  )

  uiManager.addUiPage(<DistributorsListingPage />, PAGES.DistributorsListingPage.name).addPageUiActions(
    uiManager,
    UI_ACTIONS.view_distributor_list.name,
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.view_distributor_list.name,
    uiManager.addUiPage(<DistributorDetailsPage />, PAGES.DistributorDetailsPage.name).addPageUiActions(
      uiManager,
      UI_ACTIONS.view_operators_tab_list.name,
      UI_ACTIONS.view_batteries_tab_list.name,
      UI_ACTIONS.view_charging_stations_tab_list.name,
      UI_ACTIONS.view_rfids_tab_list.name,
      UI_ACTIONS.view_partner_asset_bills_tab_list.name,
      UI_ACTIONS.block_unblock_operator.name,
      UI_ACTIONS.archive_unarchive_operator.name,
    )
  )
  
  uiManager.addUiPage(<FleetOwnersListingPage />, PAGES.FleetOwnersListingPage.name).addPageUiActions(
    uiManager,
    UI_ACTIONS.view_fleet_owner_details.name
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.view_fleet_owner_details.name,
    uiManager.addUiPage(<ShowFleetOwnerPage />, PAGES.ShowFleetOwnerPage.name).addPageUiActions(
      uiManager,
      UI_ACTIONS.view_customers_under_fo_list.name,
      UI_ACTIONS.view_fleet_owner_groups_list.name,
      UI_ACTIONS.view_user_documents.name,
      UI_ACTIONS.view_fleet_owner_lease_offers.name,
    ),
    uiManager.linkUiActionToPage(
      UI_ACTIONS.view_fleet_owner_lease_offers.name,
      uiManager.addUiPage(<LeaseOfferListingTab />, PAGES.LeaseOfferListingTab.name).addPageUiActions(
        uiManager,
        UI_ACTIONS.create_lease_offer.name,
        UI_ACTIONS.update_lease_offer.name,
        UI_ACTIONS.roll_over_configs_for_lease_offer.name
      ),
      uiManager.linkUiActionToPage(
        UI_ACTIONS.create_lease_offer.name,
        uiManager.addUiPage(<NewLeaseOfferPage />, PAGES.NewLeaseOfferPage.name)
      ),
      uiManager.linkUiActionToPage(
        UI_ACTIONS.update_lease_offer.name,
        uiManager.addUiPage(<EditLeaseOfferPage />, PAGES.EditLeaseOfferPage.name)
      ),
      uiManager.linkUiActionToPage(
        UI_ACTIONS.roll_over_configs_for_lease_offer.name,
        uiManager.addUiPage(<RolloverConfigsPage />, PAGES.RolloverConfigsPage.name).addPageUiActions(
          uiManager,
          UI_ACTIONS.create_rollover_config.name,
          UI_ACTIONS.update_rollover_config.name,
        ),
        uiManager.linkUiActionToPage(
          UI_ACTIONS.create_rollover_config.name,
          uiManager.addUiPage(<NewRollOverConfigPage />, PAGES.NewRollOverConfigPage.name)
        ),
        uiManager.linkUiActionToPage(
          UI_ACTIONS.update_rollover_config.name,
          uiManager.addUiPage(<EditRollOverConfigPage />, PAGES.EditRollOverConfigPage.name)
        ),
      )
    )
  )

  uiManager.addUiPage(<HeadUsersListingPage />, PAGES.HeadUsersListingPage.name).addPageUiActions(
    uiManager,
    UI_ACTIONS.create_head_user.name,
    UI_ACTIONS.update_head_user.name,
    UI_ACTIONS.map_head_user.name,
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.create_head_user.name,
    uiManager.addUiPage(<NewHeadUserPage />, PAGES.NewHeadUserPage.name)
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.update_head_user.name,
    uiManager.addUiPage(<EditHeadUserPage />, PAGES.EditHeadUserPage.name)
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.map_head_user.name,
    uiManager.addUiPage(<MapHeadUserPage />, PAGES.MapHeadUserPage.name).addPageUiActions(
      uiManager,
      UI_ACTIONS.delete_area_user_mapping.name
    )
  )

  uiManager.addUiPage(<BatteriesListingPage />, PAGES.BatteriesListingPage.name)
  uiManager.addUiPage(<BikesListingPage />, PAGES.BikesListingPage.name)
  uiManager.addUiPage(<VehiclesListingPage />, PAGES.VehiclesListingPage.name)
  uiManager.addUiPage(<VehicleTypesListingPage />, PAGES.VehicleTypesListingPage.name)
  uiManager.addUiPage(<InspectionsItemsPage />, PAGES.InspectionsItemsPage.name)
  uiManager.addUiPage(<WarehousesListingPage />, PAGES.WarehousesListingPage.name)

  uiManager.addUiPage(<BatteryModelsListingPage />, PAGES.BatteryModelsListingPage.name).addPageUiActions(
    uiManager,
    UI_ACTIONS.create_battery_model.name,
    UI_ACTIONS.update_battery_model.name,
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.create_battery_model.name,
    uiManager.addUiPage(<NewBatteryModelPage />, PAGES.NewBatteryModelPage.name)
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.update_battery_model.name,
    uiManager.addUiPage(<EditBatteryModelPage />, PAGES.EditBatteryModelPage.name)
  )

  uiManager.addUiPage(<ChargingStationsListingPage />, PAGES.ChargingStationsListingPage.name)

  uiManager.addUiPage(<WorkOrdersListingPage />, PAGES.WorkOrdersListingPage.name).addPageUiActions(
    uiManager,
    UI_ACTIONS.view_work_order_details.name,
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.view_work_order_details.name,
    uiManager.addUiPage(<ShowWorkOrdersPage />, PAGES.ShowWorkOrdersPage.name)
  )

  uiManager.addUiPage(<EarningsListingPage />, PAGES.EarningsListingPage.name)
  uiManager.addUiPage(<PartnerBillingsListingPage />, PAGES.PartnerBillingsListingPage.name).addPageUiActions(
    uiManager,
    UI_ACTIONS.view_partner_billing.name,
    UI_ACTIONS.view_partner_billing_status_update.name
  )

  uiManager.linkUiActionToPage(
    UI_ACTIONS.view_partner_billing.name,
    uiManager.addUiPage(<PartnerBillingsShowPage />, PAGES.PartnerBillingsShowPage.name).addPageUiActions(
      uiManager,
      UI_ACTIONS.view_date_wise_swap_earnings.name
    )
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.view_date_wise_swap_earnings.name,
    uiManager.addUiPage(<PerDayEarningShowPage />, PAGES.PerDayEarningShowPage.name)
  )


  uiManager.addUiPage(<ElectricityBillingsListingPage />, PAGES.ElectricityBillingsListingPage.name)
  uiManager.addUiPage(<ElectricityClaimsListingPage />, PAGES.ElectricityClaimsListingPage.name).addPageUiActions(
    uiManager,
    UI_ACTIONS.view_electricity_billing.name,
  )

  uiManager.addUiPage(<ElectricityConfigsListingPage />, PAGES.ElectricityConfigsListingPage.name)
  uiManager.addUiPage(<ElectricityServiceProvidersListingPage />, PAGES.ElectricityServiceProvidersListingPage.name)

  uiManager.addUiPage(<OffersListingPage />, PAGES.OffersListingPage.name).addPageUiActions(
    uiManager,
    UI_ACTIONS.create_offer.name,
    UI_ACTIONS.update_offer.name
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.create_offer.name,
    uiManager.addUiPage(<NewOfferPage />, PAGES.NewOfferPage.name)
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.update_offer.name,
    uiManager.addUiPage(<EditOfferPage />, PAGES.EditOfferPage.name)
  )

  uiManager.addUiPage(<PermissionsConfigPage />, PAGES.PermissionsConfigPage.name)
  uiManager.addUiPage(<CrmUsersListingPage />, PAGES.CrmUsersListingPage.name).addPageUiActions(
    uiManager,
    UI_ACTIONS.create_crm_user.name,
    UI_ACTIONS.update_crm_user.name
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.create_crm_user.name,
    uiManager.addUiPage(<NewCrmUserPage />, PAGES.NewCrmUserPage.name)
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.update_crm_user.name,
    uiManager.addUiPage(<EditCrmUserPage />, PAGES.EditCrmUserPage.name)
  )

  uiManager.addUiPage(<SchemesListingPage />, PAGES.SchemesListingPage.name).addPageUiActions(
    uiManager,
    UI_ACTIONS.create_scheme.name,
    UI_ACTIONS.update_scheme.name
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.create_scheme.name,
    uiManager.addUiPage(<NewSchemePage />, PAGES.NewSchemePage.name)
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.update_scheme.name,
    uiManager.addUiPage(<EditSchemePage />, PAGES.EditSchemePage.name)
  )

  uiManager.addUiPage(<SecurityAmountsListingPage />, PAGES.SecurityAmountsListingPage.name).addPageUiActions(
    uiManager,
    UI_ACTIONS.create_security_amount.name,
    UI_ACTIONS.update_security_amount.name
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.create_security_amount.name,
    uiManager.addUiPage(<NewSecurityAmountPage />, PAGES.NewSecurityAmountPage.name)
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.update_security_amount.name,
    uiManager.addUiPage(<EditSecurityAmountPage />, PAGES.EditSecurityAmountPage.name)
  )

  uiManager.addUiPage(<AddonsListingPage />, PAGES.AddonsListingPage.name).addPageUiActions(
    uiManager,
    UI_ACTIONS.create_addon.name,
    UI_ACTIONS.update_addon.name,
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.create_addon.name,
    uiManager.addUiPage(<NewAddonPage />, PAGES.NewAddonPage.name)
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.update_addon.name,
    uiManager.addUiPage(<EditAddonPage />, PAGES.EditAddonPage.name)
  )

  uiManager.addUiPage(<OfferAddonsListingPage />, PAGES.OfferAddonsListingPage.name).addPageUiActions(
    uiManager,
    UI_ACTIONS.create_offer_addon.name,
    UI_ACTIONS.update_offer_addon.name,
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.create_offer_addon.name,
    uiManager.addUiPage(<NewOfferAddonPage />, PAGES.NewOfferAddonPage.name)
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.update_offer_addon.name,
    uiManager.addUiPage(<EditOfferAddonPage />, PAGES.EditOfferAddonPage.name)
  )

  uiManager.addUiPage(<ServiceCentersListingPage />, PAGES.ServiceCentersListingPage.name).addPageUiActions(
    uiManager,
    UI_ACTIONS.create_service_center.name,
    UI_ACTIONS.view_service_center.name,
    UI_ACTIONS.update_service_center.name,
  )

  uiManager.linkUiActionToPage(
    UI_ACTIONS.create_service_center.name,
    uiManager.addUiPage(<NewServiceCenterPage />, PAGES.NewServiceCenterPage.name)
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.update_service_center.name,
    uiManager.addUiPage(<EditServiceCenterPage />, PAGES.EditServiceCenterPage.name)
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.view_service_center.name,
    uiManager.addUiPage(<ShowServiceCenterPage />, PAGES.ShowServiceCenterPage.name).addPageUiActions(
      uiManager,
      UI_ACTIONS.view_service_center_work_orders_tab_list.name,
      UI_ACTIONS.view_service_center_coordinators_tab_list.name,
      UI_ACTIONS.view_service_center_technicians_tab_list.name,
      UI_ACTIONS.view_service_center_rfids_tab_list.name,
      UI_ACTIONS.view_service_center_batteries_tab_list.name,
      UI_ACTIONS.view_service_center_vehicles_tab_list.name,
      UI_ACTIONS.view_service_center_operational_pincodes_tab_list.name,
      UI_ACTIONS.create_technician.name,
      UI_ACTIONS.update_technician.name,
      UI_ACTIONS.create_coordinator.name,
      UI_ACTIONS.update_coordinator.name,
    ),
    uiManager.linkUiActionToPage(
      UI_ACTIONS.create_technician.name,
      uiManager.addUiPage(<NewTechnicianPage />, PAGES.NewTechnicianPage.name)
    ),
    uiManager.linkUiActionToPage(
      UI_ACTIONS.update_technician.name,
      uiManager.addUiPage(<EditTechnicianPage />, PAGES.EditTechnicianPage.name)
    ),
    uiManager.linkUiActionToPage(
      UI_ACTIONS.create_coordinator.name,
      uiManager.addUiPage(<NewCoordinatorPage />, PAGES.NewCoordinatorPage.name)
    ),
    uiManager.linkUiActionToPage(
      UI_ACTIONS.update_coordinator.name,
      uiManager.addUiPage(<EditCoordinatorPage />, PAGES.EditCoordinatorPage.name)
    ),
  )


  uiManager.addUiPage(<WalletCashbacksListingPage />, PAGES.WalletCashbacksListingPage.name)

  uiManager.addUiPage(<UploaderHistoryListingPage />, PAGES.UploaderHistoryListingPage.name)

  uiManager.addUiPage(<ComplaintCategoriesListingPage />, PAGES.ComplaintCategoriesListingPage.name).addPageUiActions(
    uiManager,
    UI_ACTIONS.create_complaint_category.name,
    UI_ACTIONS.update_complaint_category.name,
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.create_complaint_category.name,
    uiManager.addUiPage(<NewComplaintCategoryPage />, PAGES.NewComplaintCategoryPage.name)
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.update_complaint_category.name,
    uiManager.addUiPage(<EditComplaintCategoryPage />, PAGES.EditComplaintCategoryPage.name)
  )

  uiManager.addUiPage(<WalletTransactionsListingPage />, PAGES.WalletTransactionsListingPage.name)
  uiManager.addUiPage(<GeneralReportsListingPage />, PAGES.GeneralReportsListingPage.name)

  uiManager.addUiPage(<TallyTransactionsListingPage />, PAGES.TallyTransactionsListingPage.name).addPageUiActions(
    uiManager,
    UI_ACTIONS.approve_tally_transaction.name,
    UI_ACTIONS.reject_tally_transaction.name,
  )

  uiManager.addUiPage(<BatteryTransactionsListingPage />, PAGES.BatteryTransactionsListingPage.name)
  uiManager.addUiPage(<TransactionOrderListingPage />, PAGES.TransactionOrdersPage.name)


  uiManager.addUiPage(<RfidCardsListingPage />, PAGES.RfidCardsListingPage.name).addPageUiActions(
    uiManager,
    UI_ACTIONS.block_unblock_rfid_card.name,
    UI_ACTIONS.mark_defective_rfid_card.name,
  )

  uiManager.addUiPage(<ChallansListingPage />, PAGES.ChallansListingPage.name)
  uiManager.addUiPage(<UploadFilesPage />, PAGES.UploadFilesPage.name)

  uiManager.addUiPage(<RentalBookingsPage />, PAGES.RentalBookingsPage.name)

  uiManager.addUiPage(<RentalCustomersPage />, PAGES.RentalCustomersPage.name).addPageUiActions(
    uiManager,
    UI_ACTIONS.view_rental_customer.name,
    UI_ACTIONS.view_rental_battery_swaps_tab.name,
    UI_ACTIONS.view_rental_bookings_tab.name,
    UI_ACTIONS.view_rental_customer_wallet_transactions_tab.name,
  )

  uiManager.linkUiActionToPage(
    UI_ACTIONS.view_rental_customer.name,
    uiManager.addUiPage(<ShowRentalCustomerPage />, PAGES.ShowRentalCustomerPage.name)
  )

  uiManager.addUiPage(<AssetEarningsConfigPage />, PAGES.AssetEarningsConfigPage.name)

  uiManager.addUiPage(<LeadsListingPage />, PAGES.LeadsListingPage.name)

  uiManager.addUiPage(<LeadsEarningConfigsPage />, PAGES.LeadsEarningConfigsPage.name).addPageUiActions(
    uiManager,
    UI_ACTIONS.create_leads_earning_config.name,
    UI_ACTIONS.update_leads_earning_config.name,
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.create_leads_earning_config.name,
    uiManager.addUiPage(<NewLeadsEarningConfigsPage />, PAGES.NewLeadsEarningConfigsPage.name)
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.update_leads_earning_config.name,
    uiManager.addUiPage(<EditLeadsEarningConfigsPage />, PAGES.EditLeadsEarningConfigsPage.name)
  )

  uiManager.addUiPage(<ServiceTypeMappingPage />, PAGES.ServiceTypeMappingPage.name).addPageUiActions(
    uiManager,
    UI_ACTIONS.create_service_type_mapping.name,
    UI_ACTIONS.update_service_type_mapping.name,
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.create_service_type_mapping.name,
    uiManager.addUiPage(<NewServiceTypeMappingPage />, PAGES.NewServiceTypeMappingPage.name)
  )

  uiManager.addUiPage(<VoltUpAllocationKitListingPage />, PAGES.VoltUpAllocationKitListingPage.name).addPageUiActions(
    uiManager,
    UI_ACTIONS.create_vak.name,
    UI_ACTIONS.update_vak.name,
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.create_vak.name,
    uiManager.addUiPage(<NewVoltUpAllocationKitPage />, PAGES.NewVoltUpAllocationKitPage.name)
  )
  uiManager.linkUiActionToPage(
    UI_ACTIONS.update_vak.name,
    uiManager.addUiPage(<EditVoltUpAllocationKitPage />, PAGES.EditVoltUpAllocationKitPage.name)
  )

  uiManager.addUiPage(<SearchUserPage />, PAGES.SearchUserPage.name)

  uiManager.addUiPage(<VoltUpAllocationKitReportsListingPage />, PAGES.VoltUpAllocationKitReportsListingPage.name)

  uiManager.addUiPage(<VoltUpAllocationKitTransactionsListingPage />, PAGES.VoltUpAllocationKitTransactionsListingPage.name)

  uiManager.addUiPage(<ChargingZonesMapPage />, PAGES.ChargingZonesMapPage.name)

  uiManager.addUiPage(<SupportPage />, PAGES.SupportPage.name)
  // uiManager.addUiPage(<OperationsPage />, PAGES.OperationsPage.name)

}

export default setupPages;
